import './App.css';
import './v56-signup';
import V56Signup from "./v56-signup";
import {
  GoogleReCaptchaProvider
} from 'react-google-recaptcha-v3';

const SITE_KEY = "6LcVoYQfAAAAAPHDDHzUgp_q1UywxwhmjVLcwUt4"

function App() {
  return (
      <GoogleReCaptchaProvider reCaptchaKey={SITE_KEY}>
      <V56Signup />
      </GoogleReCaptchaProvider>
  );
}

export default App;
